import * as globals from '@wandb/weave/common/css/globals.styles';
import styled from 'styled-components';

export const PageWithSidebar = styled.div`
  display: flex;
  height: 100%;
  min-width: 0;

  @media only screen and (max-width: ${globals.MEDIUM_BREAKPOINT}px) {
    display: block;
  }
`;
PageWithSidebar.displayName = 'S.PageWithSidebar';

const sidebarBaseStyles = `
  width: 300px;
  padding: 16px 12px;
  background-color: white;
  border-right: 1px solid ${globals.MOON_200};
`;
const sidebarBoxShadow = `0px 12px 24px 0px ${globals.hexToRGB(
  globals.OBLIVION,
  0.12
)}`;

export const InlineSidebar = styled.div<{shadow?: boolean}>`
  ${sidebarBaseStyles}
  position: relative;
  overflow-y: auto;
  max-width: 300px;
  flex-shrink: 0;
  box-shadow: ${props => (props.shadow ? sidebarBoxShadow : 'none')};
  transition: box-shadow 300ms;

  @media only screen and (max-width: ${globals.MEDIUM_BREAKPOINT}px) {
    min-height: 100%;
    min-width: 100vw;
    border-right: unset;
    border-bottom: 1px solid ${globals.MOON_200};
  }
`;
InlineSidebar.displayName = 'S.InlineSidebar';

export const FloatingSidebar = styled.div<{
  bodyScrollHeight: number;
  // This is a floating absolutely positioned element, so it's an exception to the rule.
  // oxlint-disable-next-line wandb/no-calc-100vh-pixel-math
}>`
  ${sidebarBaseStyles}
  overflow-y: auto;
  height: max(
    calc(100vh - ${globals.SEARCH_NAV_HEIGHT}),
    calc(${props => props.bodyScrollHeight}px - ${globals.SEARCH_NAV_HEIGHT})
  );
  position: absolute;
  left: 0;
  top: 60px;
  z-index: 999;
  box-shadow: ${sidebarBoxShadow};
  @media only screen and (max-width: ${globals.MEDIUM_BREAKPOINT}px) {
    width: max(300px, 85%);
  }
`;
FloatingSidebar.displayName = 'S.FloatingSidebar';

export const Content = styled.div<{
  background?: string;
}>`
  flex: 1 1 auto;
  min-width: 0;
  height: 100%;
  overflow: auto;
  padding: 16px 40px;
  background: ${props =>
    props.background != null ? props.background : 'unset'};

  @media only screen and (max-width: ${globals.MEDIUM_BREAKPOINT}px) {
    padding: 16px 24px;
  }
`;
Content.displayName = 'S.Content';
